import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { globalHistory } from '@reach/router';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

function SEO({
  description, meta, title,
}) {
  const { site, file: { publicURL: image } } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        file(name: {regex: "/wdental-thumbnail/g"}) {
          publicURL
        }
      }
    `,
  );

  const metaDescription = description || site.siteMetadata.description;
  const { location } = globalHistory;

  return (
    <Helmet
      htmlAttributes={{
        lang: 'pt-BR',
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:url',
          content: location.href
        },
        {
          property: 'og:image',
          content: image
        }
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  meta: [],
  description: '',
};

SEO.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default memo(SEO);
